import Vue from "vue";
import store, { actions } from "./store";

import MastheadNavWithImages from "./vue-components/MastheadNavWithImages.vue";
import MastheadMobile from "./vue-components/mobile/MastheadMobile.vue";

export default (config) =>
  config.map(({ targetSelector: el, navData, searchData}) => {
    actions.setNavData(navData);
    actions.mergeSiteSearchData(searchData);

    const app = new Vue({
      el,
      name: "mastheadNavWithImages",
      data() {
        return store;
      },
      render(h) {
        const component = this.isDesktop ? MastheadNavWithImages : MastheadMobile;
        return h(component);
      },
    });

    return {
      config,
      app,
    };
  });
